// Mock data for Technical Service Website

export const services = [
  {
    id: 1,
    name: 'Buzdolabı Tamiri',
    icon: 'Refrigerator',
    description: 'Tüm markalarda profesyonel buzdolabı tamir ve bakım hizmeti',
    features: ['Soğutma sistemleri', 'Termostat değişimi', 'Gaz dolumu', 'Periyodik bakım']
  },
  {
    id: 2,
    name: 'Çamaşır Makinesi Tamiri',
    icon: 'WashingMachine',
    description: 'Çamaşır makinesi arıza tespiti ve onarım hizmetleri',
    features: ['Motor tamiri', 'Pompa değişimi', 'Elektronik kart tamiri', 'Su kaçağı onarımı']
  },
  {
    id: 3,
    name: 'Bulaşık Makinesi Tamiri',
    icon: 'Utensils',
    description: 'Bulaşık makinesi bakım ve onarım hizmetleri',
    features: ['Yıkama sistemleri', 'Isıtıcı değişimi', 'Kireç temizliği', 'Elektronik onarım']
  },
  {
    id: 4,
    name: 'Kombi Tamiri',
    icon: 'Flame',
    description: 'Kombi bakım, tamir ve montaj hizmetleri',
    features: ['Yıllık bakım', 'Kazan temizliği', 'Elektronik kart', 'Gaz ayarları']
  },
  {
    id: 5,
    name: 'Klima Tamiri',
    icon: 'Wind',
    description: 'Klima montaj, bakım ve tamir hizmetleri',
    features: ['Gaz dolumu', 'Filtre temizliği', 'Kompresör tamiri', 'Montaj hizmeti']
  },
  {
    id: 6,
    name: 'Fırın Tamiri',
    icon: 'Flame',
    description: 'Ankastre ve serbest fırın tamir ve bakım hizmetleri',
    features: ['Termostat değişimi', 'Rezistans tamiri', 'Elektronik kart onarımı', 'Cam değişimi']
  },
  {
    id: 7,
    name: 'Klima Montaj',
    icon: 'Wind',
    description: 'Profesyonel klima montaj ve kurulum hizmetleri',
    features: ['Tüm BTU seçenekleri', 'Profesyonel montaj', 'Gaz dolumu dahil', 'Garanti belgeli']
  },
  {
    id: 8,
    name: 'Termosifon Montaj',
    icon: 'Sun',
    description: 'Güneş enerjili su ısıtma sistemleri montajı',
    features: ['Profesyonel kurulum', 'Sistem kontrolü', 'Verimlilik testi', 'Bakım hizmeti']
  }
];

export const testimonials = [
  {
    id: 1,
    name: 'Ahmet Yılmaz',
    service: 'Buzdolabı Tamiri',
    rating: 5,
    comment: 'Çok profesyonel bir ekip. Aynı gün gelip arızayı hemen hallettiler. Kesinlikle tavsiye ederim.',
    date: '2024-03-15'
  },
  {
    id: 2,
    name: 'Zeynep Kaya',
    service: 'Çamaşır Makinesi Tamiri',
    rating: 5,
    comment: 'Güvenilir ve hızlı servis. Fiyatları da çok makul. Teşekkür ederim.',
    date: '2024-03-10'
  },
  {
    id: 3,
    name: 'Mehmet Demir',
    service: 'Kombi Bakımı',
    rating: 5,
    comment: 'Yıllık kombi bakımımı yaptırdım. İşlerini çok iyi yapıyorlar, tekrar tercih edeceğim.',
    date: '2024-03-05'
  },
  {
    id: 4,
    name: 'Ayşe Şahin',
    service: 'Klima Montajı',
    rating: 5,
    comment: 'Klima montajını çok temiz ve düzenli bir şekilde yaptılar. Çok memnun kaldım.',
    date: '2024-02-28'
  }
];

export const stats = [
  { label: 'Mutlu Müşteri', value: '5000+' },
  { label: 'Yıllık Deneyim', value: '15+' },
  { label: 'Teknik Personel', value: '25+' },
  { label: 'Hizmet Bölgesi', value: '50+' }
];

export const mockRequests = [
  {
    id: 1,
    customerName: 'Ali Veli',
    phone: '0551 847 8521',
    email: 'ali@example.com',
    service: 'Buzdolabı Tamiri',
    address: 'Kuşadası Merkez, Aydın',
    description: 'Buzdolabım soğutmuyor',
    status: 'pending',
    date: '2024-03-20',
    assignedTo: null,
    createdAt: '2024-03-20T10:30:00Z'
  },
  {
    id: 2,
    customerName: 'Fatma Yılmaz',
    phone: '0543 987 6543',
    email: 'fatma@example.com',
    service: 'Çamaşır Makinesi Tamiri',
    address: 'Davutlar, Kuşadası',
    description: 'Makine su almıyor',
    status: 'assigned',
    date: '2024-03-19',
    assignedTo: 'Mehmet Teknisyen',
    createdAt: '2024-03-19T14:20:00Z'
  },
  {
    id: 3,
    customerName: 'Hasan Öz',
    phone: '0555 444 3333',
    email: 'hasan@example.com',
    service: 'Kombi Bakımı',
    address: 'Söke, Aydın',
    description: 'Yıllık bakım zamanı geldi',
    status: 'completed',
    date: '2024-03-18',
    assignedTo: 'Ahmet Teknisyen',
    createdAt: '2024-03-18T09:15:00Z',
    completedAt: '2024-03-18T16:30:00Z',
    completionData: {
      parts: 'Termostat sensörü',
      cost: '450',
      workDone: 'Termostat sensörü değiştirildi, sistem bakımı yapıldı'
    }
  }
];

// Geçmiş kayıtlar (2 yıllık arşiv)
export const mockHistoricalRecords = [
  {
    id: 101,
    customerName: 'Mehmet Acar',
    phone: '0532 111 2222',
    email: 'mehmet@example.com',
    service: 'Buzdolabı Tamiri',
    address: 'Kuşadası, Aydın',
    description: 'Kompresör değişimi',
    status: 'completed',
    date: '2023-11-15',
    assignedTo: 'Ahmet Teknisyen',
    createdAt: '2023-11-15T10:00:00Z',
    completedAt: '2023-11-15T15:30:00Z',
    completionData: {
      parts: 'Kompresör',
      cost: '1200',
      workDone: 'Kompresör değiştirildi, gaz dolumu yapıldı'
    }
  },
  {
    id: 102,
    customerName: 'Elif Yıldız',
    phone: '0541 222 3333',
    email: 'elif@example.com',
    service: 'Çamaşır Makinesi Tamiri',
    address: 'Söke, Aydın',
    description: 'Motor arızası',
    status: 'completed',
    date: '2023-09-20',
    assignedTo: 'Mehmet Teknisyen',
    createdAt: '2023-09-20T11:00:00Z',
    completedAt: '2023-09-20T16:00:00Z',
    completionData: {
      parts: 'Motor karbon fırçası',
      cost: '650',
      workDone: 'Motor karbon fırçası değiştirildi'
    }
  },
  {
    id: 103,
    customerName: 'Can Demir',
    phone: '0533 444 5555',
    email: 'can@example.com',
    service: 'Klima Bakımı',
    address: 'Davutlar, Kuşadası',
    description: 'Periyodik bakım',
    status: 'completed',
    date: '2023-06-10',
    assignedTo: 'Ahmet Teknisyen',
    createdAt: '2023-06-10T09:00:00Z',
    completedAt: '2023-06-10T11:30:00Z',
    completionData: {
      parts: 'Filtre',
      cost: '350',
      workDone: 'Filtre değişimi, gaz kontrolü yapıldı'
    }
  }
];

export const mockTechnicians = [
  { 
    id: 1, 
    name: 'Mehmet Teknisyen', 
    username: 'mehmet',
    password: 'mehmet123',
    email: 'mehmet@teknikservis.com', 
    specialty: 'Beyaz Eşya',
    createdBy: 'admin'
  },
  { 
    id: 2, 
    name: 'Ahmet Teknisyen', 
    username: 'ahmet',
    password: 'ahmet123',
    email: 'ahmet@teknikservis.com', 
    specialty: 'Kombi & Klima',
    createdBy: 'admin'
  },
  { 
    id: 3, 
    name: 'Mustafa Teknisyen',
    username: 'mustafa', 
    password: 'mustafa123',
    email: 'mustafa@teknikservis.com', 
    specialty: 'Genel',
    createdBy: 'admin'
  }
];

export const mockAppointments = [
  {
    id: 1,
    requestId: 2,
    customerName: 'Fatma Yılmaz',
    service: 'Çamaşır Makinesi Tamiri',
    address: 'Davutlar, Kuşadası',
    date: '2024-03-21',
    time: '10:00',
    status: 'scheduled',
    notes: 'Makine su almıyor'
  },
  {
    id: 2,
    requestId: 1,
    customerName: 'Ali Veli',
    service: 'Buzdolabı Tamiri',
    address: 'Kuşadası Merkez, Aydın',
    date: '2024-03-22',
    time: '14:00',
    status: 'scheduled',
    notes: 'Buzdolabı soğutmuyor'
  }
];

export const brands = [
  'Arçelik', 'Beko', 'Bosch', 'Siemens', 'Samsung', 
  'LG', 'Vestel', 'Altus', 'Profilo', 'Whirlpool',
  'Electrolux', 'AEG', 'Vaillant', 'Baymak', 'Demirdöküm'
];